import { IdentityService } from '../shared/api/IdentityService';

const { PdsRoleClient, PdsUserClient, UserLookupClient } = IdentityService;

export const PdsRoleClientAPI = new PdsRoleClient(process.env.REACT_APP_BASE_URL);
export const PdsUserClientAPI = new PdsUserClient(process.env.REACT_APP_BASE_URL);
export const UserLookupClientAPI = new UserLookupClient(process.env.REACT_APP_BASE_URL);
